import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import TaskForceLogin from '@/modules/common/pages/TaskForceLogin.tsx';
import TaskPublic from '@/modules/common/pages/TaskPublic.tsx';
import { commonPaths } from '@/modules/common/routes.tsx';
import { getDashboardRoutes } from '@/modules/admin-dashboard/routes.tsx';
import { getEmployeeDashboardRoutes } from '@/modules/employee-dashboard/routes.tsx';
import { Spinner } from 'ui';
import RootRoute from '@/RootRoute.tsx';

const NotFound = lazy(() => import('./modules/common/pages/NotFound.tsx'));
const Task = lazy(() => import('./modules/common/pages/Task.tsx'));
const PublicDocument = lazy(() => import('./modules/common/pages/PublicDocument.tsx'));
const PublicFolder = lazy(() => import('./modules/common/pages/PublicFolder.tsx'));
const IncidentReporting = lazy(() => import('./modules/common/pages/IncidentReporting.tsx'));

export const AppRoutes = () => {
  return (
    <Suspense
      fallback={
        <div className="flex h-[100dvh] w-full items-center justify-center">
          <Spinner size="lg" variant="primary" />
        </div>
      }
    >
      <Routes>
        <Route path="/" element={<RootRoute />} />
        <Route path="/login" element={<RootRoute />} />
        {getDashboardRoutes()}
        {getEmployeeDashboardRoutes()}
        <Route path={commonPaths.dynamic.task()} element={<Task />} />
        <Route path={commonPaths.static.taskPublic} element={<TaskPublic />} />
        <Route path={commonPaths.static.taskForceLogin} element={<TaskForceLogin />} />
        <Route path={commonPaths.dynamic.publicDocument()} element={<PublicDocument />} />
        <Route path={commonPaths.dynamic.publicFolder()} element={<PublicFolder />} />
        <Route path={commonPaths.static.incidentReporting} element={<IncidentReporting />} />
        <Route path={commonPaths.static.notFound} element={<NotFound />} />
        <Route path="*" element={<Navigate to={commonPaths.static.notFound} replace />} />
      </Routes>
    </Suspense>
  );
};
